import {
  ADDITIONAL_INFORMATION_STATUS,
  AdditionalInformation,
} from '@hivebrite/design-system/AdditionalInformation';
import { Box } from '@hivebrite/design-system/Box';

import dayjs from 'hb-react/shared/utils/dayjs/dayjs';

const FixedEndWarning = ({ expireMonth, validity }) => (
  <Box display="block" fontStyle="italic">
    <AdditionalInformation
      id="expire-month-notice"
      status={ADDITIONAL_INFORMATION_STATUS.ALERT}
    >
      {s__(
        'Memberships|You are buying a membership with a fixed end month of %{expireMonth}. Therefore the expiration date of your subscription will be %{validity}',
      ).i__({ expireMonth, validity: dayjs(validity).format('L') })}
    </AdditionalInformation>
  </Box>
);

export default FixedEndWarning;
